/**
 * Default fixed panel width (px) used when a consumer does not pass
 * `width` to `SidePanel`. Product surfaces with a specific width must
 * override explicitly.
 */
export const SIDE_PANEL_DEFAULT_WIDTH = 400;

/**
 * Default viewport width (px) at which `SidePanel` flips between
 * persistent push mode (≥ this value, no scrim) and temporary overlay
 * mode (< this value, scrim active).
 *
 * Paired primitive + layout rule:
 * - `SidePanel` builds its overlay query as
 *   `(max-width: ${overlayBelowPx - 0.05}px)`.
 * - `SidePanelLayout` builds its push query as
 *   `(min-width: ${overlayBelowPx}px)`.
 *
 * The `0.05px` offset guarantees a viewport at exactly
 * `overlayBelowPx` matches push mode but not overlay mode, so the two
 * never coexist at the boundary.
 */
export const SIDE_PANEL_DEFAULT_OVERLAY_BREAKPOINT_PX = 1100;
